"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _Conversation = _interopRequireDefault(require("./model/Conversation"));

var _immutable = require("immutable");

var BASE_URI = 'composition/v1/conversations';
var OBJECT_TYPE_CONTENT = 0;
var OBJECT_TYPE_COMPOSITION = 1;
var OBJECT_SUBTYPE_UNMAPPED = 0;

var getConversationUri = function getConversationUri(id) {
  return BASE_URI + "/" + id;
};

var getSummaryUri = function getSummaryUri(id) {
  return BASE_URI + "/summary/" + id;
};

var getFetchOptions = function getFetchOptions() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = (0, _immutable.Map)({
    limit: 100,
    objectType__in: [OBJECT_TYPE_CONTENT, OBJECT_TYPE_COMPOSITION],
    offset: 0
  }).merge(data).toJS();
  return {
    query: options
  };
};

var getCreateOptions = function getCreateOptions() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = (0, _immutable.Map)({
    objectSubType: OBJECT_SUBTYPE_UNMAPPED,
    objectType: OBJECT_TYPE_COMPOSITION
  }).merge(data).toJS();
  return {
    data: options
  };
};

var ConversationsManager = /*#__PURE__*/function () {
  function ConversationsManager() {
    (0, _classCallCheck2.default)(this, ConversationsManager);
  }

  (0, _createClass2.default)(ConversationsManager, [{
    key: "fetch",
    value: function fetch(id) {
      return _apiClient.default.get(getSummaryUri(id), getFetchOptions({
        objectId: id
      }));
    }
  }, {
    key: "create",
    value: function create(correlationId, objectId, highlightStart, highlightEnd, highlightText) {
      return _apiClient.default.post(BASE_URI, getCreateOptions({
        correlationId: correlationId,
        objectId: objectId,
        highlightStart: highlightStart,
        highlightEnd: highlightEnd,
        highlightText: highlightText
      })).then(_Conversation.default.fromJS);
    }
  }, {
    key: "deleteConversation",
    value: function deleteConversation(id) {
      return _apiClient.default.delete(getConversationUri(id));
    }
  }, {
    key: "safelyDeleteEmptyConversation",
    value: function safelyDeleteEmptyConversation(id) {
      return _apiClient.default.delete(getConversationUri(id) + "/safe");
    }
  }]);
  return ConversationsManager;
}();

exports.default = ConversationsManager;
module.exports = exports.default;